export const DashboardIcon = (props: React.HTMLAttributes<SVGElement>) => {
  return (
    <svg
      width="18"
      height="19"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 19"
      fill="none"
      {...props}
    >
      <path
        d="M16 0.416504H2C0.9 0.416504 0 1.3165 0 2.4165V16.4165C0 17.5165 0.9 18.4165 2 18.4165H16C17.1 18.4165 18 17.5165 18 16.4165V2.4165C18 1.3165 17.1 0.416504 16 0.416504ZM2 16.4165V2.4165H8V16.4165H2ZM16 16.4165H10V9.4165H16V16.4165ZM16 7.4165H10V2.4165H16V7.4165Z"
        fill="black"
      />
    </svg>
  )
}
